import { WIDGET_TEXT } from "@smallstack/typesystem";
import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const TextWidget: WidgetRegistryEntry = {
  name: WIDGET_TEXT,
  configuration: async () => (await import("./configuration")).TextWidgetConfiguration,
  component: async () => (await import("./text-widget.component")).TextWidgetComponent
};
